<template lang="html">
  <div class='center-flex'>
    <div class="login-form">
      <div class="logo">
        <img src="/img/journalisr.png" alt="Journalisr">
        <!-- <h1>journalisr</h1> -->
      </div>
      <input placeholder="email" type="text" name="email" id="emailField">
      <input placeholder="password" type="password" name="pwd" id="pwdField" @keydown='checkEnter'>
      <button ref="button" type="submit" id='submitButton' @click="login()">
      login <i class="fas fa-arrow-right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  mounted: function() {
    // window.sessionStorage.removeItem('loggedIn')
  },
  methods: {
    login: function() {
      this.$refs.button.innerHTML = '<i class="fas fa-spin fa-circle-notch"></i>'
      window.sessionStorage.setItem('loggedIn', this.$parent.createLoginHash())
      this.$parent.loggedIn = true;
      this.$router.push({
        name: 'list'
      })
    },
    checkEnter(event) {
      if (event.key == 'Enter') {
        this.login()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.logo {
  width: 300px;
  margin-bottom: 20px;
}
.logo > img {
  width: 260px;
  display: block;
  margin: 0 auto;
}
.main {
    background: var(--shade3);
}
.login-form {
    width: 300px;
    position: relative;
    font-size: small;
    padding-bottom: 70px;
}
.login-form > input {
    display: block;
    margin-bottom: 10px;
    height: 30px;
    background: var(--light);
    width: calc(100% - 6em);
    outline: none;
    padding: 0 3em;
    text-align: center;
    border:none;
}
.login-form > button {
    background: var(--light);
    border: none;
    height: 30px;
    width: 100px;
    /* outline: none; */
    cursor: pointer;
    position: absolute;
    right: 0px;
}
.login-form > button:hover {
  background: lightgrey;
}
.login-form > input:focus::-webkit-input-placeholder {
    color: transparent;
}
</style>
